export const rules = {
  email: value => {
    if (!value) return true; // Allow empty value since required rule will handle this
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(value) || "Please enter a valid email address";
  },
  required: value => {
    return !!value || "This field is required";
  },
  passwordLength: value => {
    return (
      (value && value.length >= 10) || "Password must be 10 characters or more"
    );
  }
};
